import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { TrlButtonLink } from '»components/atoms';
import { useCurrentPage } from '»utils/customHooks';

import {
  BoxBackgroundImageStyled,
  LandingPageText,
  TextContainer,
} from './AppCardAurea.styles';

export const AppCardAurea = () => {
  const location = useLocation();

  const {
    isNoAuthFormPage,
    isLoginPage,
    isOnboardingPage,
    isOnboardingAdvancedSteps,
  } = useCurrentPage(location.pathname);

  return (
    <BoxBackgroundImageStyled
      isFormPage={isNoAuthFormPage}
      isLoginPage={isLoginPage}
      isOnboardingPage={isOnboardingPage}
      isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
    >
      <TextContainer
        isFormPage={isNoAuthFormPage}
        isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
      >
        <LandingPageText
          isFormPage={isNoAuthFormPage}
          isOnboardingAdvancedSteps={isOnboardingAdvancedSteps}
        >
          <FormattedMessage id="TRLT_UI-LANDING_PAGE_SLOGAN_AUREA" />
        </LandingPageText>
        {isNoAuthFormPage && (
          <TrlButtonLink
            externalLink={
              isLoginPage
                ? 'https://www.aurea.ao/applica'
                : 'https://www.aurea.ao/conta-online'
            }
            buttonText="TRLT_UI-READ_MORE"
          />
        )}
      </TextContainer>
    </BoxBackgroundImageStyled>
  );
};
